// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607030716/js/" + chunkId + "." + {"44":"7998eff7","225":"5e30e964","481":"733b3b05","486":"8122ab79","770":"5b2d3f5b"}[chunkId] + ".0.16787157452653734.chunk.js";
};